import React from 'react';

const IconVillage = () => {
	return (
		<svg aria-hidden="true" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0.382812 13.6044V5.02747L5.38281 0.0274658L10.3828 5.02747V13.6044H0.382812ZM1.38281 12.6044H4.61359V10.2967H6.15206V12.6044H9.38281V5.42939L5.38281 1.42939L1.38281 5.42939V12.6044ZM4.61359 7.37362V5.83517H6.15206V7.37362H4.61359ZM11.9982 13.6236V4.35632L7.66936 0.0274658H9.09051L12.9982 3.93517V13.6236H11.9982ZM14.6136 13.6236V3.26399L11.3771 0.0274658H12.8175L15.6136 2.84284V13.6236H14.6136Z" fill="#545454"/>
		</svg>

	);
};

export default IconVillage;
